__turbopack_context__.v({
  "app-badges": "AppBadges-module-scss-module__I3KZoq__app-badges",
  "filled": "AppBadges-module-scss-module__I3KZoq__filled",
  "outlined": "AppBadges-module-scss-module__I3KZoq__outlined",
});
